import React, { useCallback } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Form, Select, Row, Col, Button, Divider, Spin, Input } from 'antd';
import { useTranslation } from 'react-i18next';

const CoupangShippingSettings = ({ form, returnCenters, outboundPlaces, loading, onReload }) => {
  const { t } = useTranslation();

  const handleSelectChange = useCallback((nameField, options) => (value) => {
    const selected = options.find(opt => opt.value === value);
    form.setFieldValue(['credentials', nameField], selected?.label || '');
  }, [form]);

  // Fallback options to show initially (before user clicks Load List)
  const getFallbackOption = (codeField, nameField, fallbackList) => {
    if (fallbackList && fallbackList.length > 0) return fallbackList;
    const code = form.getFieldValue(['credentials', codeField]);
    const name = form.getFieldValue(['credentials', nameField]);
    return code ? [{ value: code, label: name || code }] : [];
  };

  const sevenOptions = getFallbackOption('return_center_code_seven', 'return_center_display_text_seven', returnCenters.seven);
  const familyOptions = getFallbackOption('return_center_code_family', 'return_center_display_text_family', returnCenters.family);
  const outboundOptions = getFallbackOption('outbound_shipping_place_code', 'outbound_shipping_place_display_text', outboundPlaces);

  return (
    <>
      <Divider orientation="left">
        {t('models.ec_account.platform_settings.coupang.return_center_settings')}
      </Divider>

      {onReload && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 8, color: '#8c8c8c' }}>
            {t('models.ec_account.platform_settings.coupang.load_centers_hint')}
          </div>
          <Button
            type="default"
            icon={<DownloadOutlined />}
            onClick={onReload}
            loading={loading}
          >
            {t('models.ec_account.platform_settings.coupang.load_return_centers')}
          </Button>
        </div>
      )}

      <Spin spinning={loading}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name={['credentials', 'return_center_code_seven']}
              label={t('models.ec_account.platform_settings.coupang.return_center_seven')}
              tooltip={t('models.ec_account.platform_settings.coupang.return_center_seven_tooltip')}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder={t('models.ec_account.platform_settings.coupang.select_return_center')}
                options={sevenOptions}
                onChange={handleSelectChange('return_center_display_text_seven', sevenOptions)}
              />
            </Form.Item>
            <Form.Item name={['credentials', 'return_center_display_text_seven']} style={{ display: 'none' }}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={['credentials', 'return_center_code_family']}
              label={t('models.ec_account.platform_settings.coupang.return_center_family')}
              tooltip={t('models.ec_account.platform_settings.coupang.return_center_family_tooltip')}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder={t('models.ec_account.platform_settings.coupang.select_return_center')}
                options={familyOptions}
                onChange={handleSelectChange('return_center_display_text_family', familyOptions)}
              />
            </Form.Item>
            <Form.Item name={['credentials', 'return_center_display_text_family']} style={{ display: 'none' }}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              name={['credentials', 'outbound_shipping_place_code']}
              label={t('models.ec_account.platform_settings.coupang.outbound_shipping_place')}
              tooltip={t('models.ec_account.platform_settings.coupang.outbound_shipping_place_tooltip')}
            >
              <Select
                allowClear
                showSearch
                optionFilterProp="label"
                placeholder={t('models.ec_account.platform_settings.coupang.select_shipping_place')}
                options={outboundOptions}
                onChange={handleSelectChange('outbound_shipping_place_display_text', outboundOptions)}
              />
            </Form.Item>
            <Form.Item name={['credentials', 'outbound_shipping_place_display_text']} style={{ display: 'none' }}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default CoupangShippingSettings;
